import { createSlice } from "@reduxjs/toolkit";
import cartActionReducers from "@/redux/slice/cart/reducers/actionReducers";
import initialState from "@/redux/slice/cart/initialState";

const slice = createSlice({
  name: "cart",
  initialState,
  reducers: cartActionReducers,
});

export const {
  addUpdateCartItem,
  addUpdateCartItems,
  updateCartItemQuantity,
  setCartItems,
  setUserActionPayload,
  setGuestUserActionPayload,
  setAllowFetch,
  setIsCartUpdated,
  setServerCartErrorMessage,
  setFetchingCart,
  setUpdatingCart,
  setOOSNotified,
  setCartLocation,
  setAllowServerUpdate,
  setCartFetchingUpdating,
  appendOutOfStockSkus,
  markSkuListInStock,
  setCartTotalAmount,
  updateTotalCartItemCount,
} = slice.actions;

export default slice.reducer;
